module.exports = __webpack_public_path__ + "static/media/background.c4f17274.jpg";